/* src/app/auth/reset-password/reset-password.component.scss */
.input-group {
  position: relative;
  display: flex;
  align-items: center;
}
.input-group .input-group-addon {
  position: absolute;
  right: 10px;
  top: 40%;
  transform: translateY(-50%);
  z-index: 4;
  display: flex;
  align-items: center;
  border-bottom: none;
}
.form-control {
  padding-right: 40px;
}
/*# sourceMappingURL=reset-password.component.css.map */
